import { render } from "./Column202505.vue?vue&type=template&id=6bd42e45&scoped=true"
import script from "./Column202505.vue?vue&type=script&lang=js"
export * from "./Column202505.vue?vue&type=script&lang=js"

import "./Column202505.vue?vue&type=style&index=0&id=6bd42e45&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd42e45"]])

export default __exports__